export default __webpack_public_path__ + "static/media/more.cd58eae5.svg";